"use client";
import React, { useEffect, useState } from "react";

export const HeroSection: React.FC = () => {
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [backgroundImage, setBackgroundImage] = useState<string | null>(null);

    useEffect(() => {
        const img = new Image();
        const bgImageSrc = '/images/bg-2.jpg';

        img.src = bgImageSrc;
        img.onload = () => {
            setBackgroundImage(bgImageSrc); // Set the preloaded image
            setIsImageLoaded(true);        // Indicate that the image is loaded
        };
        img.onerror = (err) => {
            console.error("Failed to load background image:", err);
        };
    }, []);

    const handleScroll = (id: string) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: 'start',
                
            });
        }
    };
    
    return (
        <>
        {isImageLoaded ? 
            <section
                id="home"
                style={{
                    backgroundImage: isImageLoaded && backgroundImage ? `url(${backgroundImage})` : undefined,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: '100vh',
                    width: '100%'
                }}
                className="hero-wrap"
            >
                <div
                    style={{
                        height: '100%',
                        width: '100%',
                    }}
                >
                    <div className="overlay"></div>

                    <div className="container h-full flex justify-center items-center" style={{  }}>
                        <div className="row no-gutters slider-text justify-content-center align-items-center">
                            <div className="col-lg-12 d-flex align-items-center">
                                <div className="text text-center text-white">
                                    <span className="subheading">Dobrodošli u Berberaj032 </span>
                                    <h1 className="mb-4">Brzo i jednostavno do nove frizure</h1>
                                    <p>
                                        <a
                                            onClick={() => { 
                                                handleScroll("team-sections");
                                                setTimeout(() => handleScroll("team-sections"), 50);  
                                            }}
                                            className="btn btn-primary btn-outline-primary px-4 py-2"
                                        >
                                            Zakaži termin
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> : 
            <>
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            border: "4px solid #f3f3f3",
                            borderTop: "4px solid #bf925b",
                            borderRadius: "50%",
                            width: "50px",
                            height: "50px",
                            animation: "spin 1s linear infinite",
                        }}
                    ></div>
                </div>
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </>
            }
        </>
    );
}